<template>
  <div style="position: relative">
    <b-nav vertical class="base-nav">
      <b-nav-item :to="parentRoute" link-classes="back-link">
        <b-icon icon="arrow-left-square" class="mr-1" />
        {{ $t("configuration.overview") }}
      </b-nav-item>

      <b-nav-item
        link-classes="d-flex align-items-center"
        v-for="step in steps"
        :key="step.route"
        :to="{ name: step.route }"
      >
        <div>
          {{ step.title }} <span>{{ getStepDescription(step) }}</span>
        </div>
      </b-nav-item>
    </b-nav>

    <!-- Summe -->
    <div class="col-md-3 col-lg-3 col-xl-2 total fixed">
      <div class="total-price">
        <span>{{ $t("bom.totalSum") }}</span>
        {{ formatPrice(bom.total) }}
      </div>
      <div class="total-weight">
        <span>{{ $t("bom.totalWeight") }}</span>
        {{ formatWeight(bom.totalWeight) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: Array,
    sidebarOpened: Boolean,
  },
  computed: {
    bom() {
      if (this.$store.state.configurations.configurationBom) {
        return this.$store.state.configurations.configurationBom;
      }
      return {};
    },
    configuration() {
      const conf = this.$store.state.configurations.configuration;
      if (conf) {
        return conf;
      }
      return {};
    },
    parentRoute() {
      return {
        name: "shoppingCart",
        params: { projectId: this.$store.state.projects.project.number },
      };
    },
  },
  methods: {
    getStepDescription(step) {
      if (step.route == "columnTypesWithConfig") {
        let description = [];
        description.push(this.configuration.columnType);
        description.push(this.configuration.height + " mm");
        return description.join(", ");
      } else if (step.route == "jibCrane") {
        if (this.configuration.jibCrane) {
          let description = [];
          description.push(
            this.$t(
              `jibCrane.material.${this.configuration.jibCrane.craneType.toLowerCase()}`
            )
          );
          description.push(this.configuration.jibCrane.length + " mm");

          return description.join(", ");
        }
      } else if (step.route == "summary") {
        return this.$t("configuration.billOfMaterial");
      }

      return "";
    },
    formatAmount(amount) {
      return Math.round(amount * 10) / 10;
    },
    formatPrice(value) {
      if (value == null || this.bom.currency == null) return "-";
      return Intl.NumberFormat(this.$i18n.locale, {
        style: "currency",
        currency: this.bom.currency,
      }).format(value);
    },
    formatWeight(value) {
      if (value == null) return "-";
      return (
        value.toLocaleString(this.$i18n.locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + " kg"
      );
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.base-nav.nav {
  font-size: 1.2em;
  flex-grow: 1;

  & li {
    & a.nav-link {
      height: 70px;
      padding: 12px 16px;
      cursor: pointer;
      color: inherit;
      text-decoration: inherit;

      &.back-link {
        color: rgb(0, 160, 228);
        height: 50px !important;
        &:hover {
          background: none;
          text-decoration: underline;
        }
      }
      & span {
        display: block;
        opacity: 0.7;
        margin-top: 4px;
        font-size: 0.8em;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.06);
      }
      &.router-link-exact-active {
        background: rgba(0, 0, 0, 0.12);
      }
    }
  }
}

.total {
  padding: 16px;
}
.total.fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  // max-width: 375px;
}
.mobile .total{
  max-width: 375px;
}

.total-price,
.total-weight {
  display: flex;
  font-weight: 700;
}

.total span {
  flex-grow: 1;
  font-weight: 400;
}

.total-price {
  font-size: 18px;
  margin-bottom: 4px;
}

.total-weight {
  font-size: 15px;
}

.weight {
  flex-grow: 1;
}
</style>
